import { createSlice } from '@reduxjs/toolkit';
import {
  fetchEarlyTerminationDocuments,
  sendEarlyTerminationRequest,
} from './thunks';

export interface RequestsState {
  earlyContractTerminationLoading?: boolean;
  earlyContractTerminationError?: string;
  earlyContractTerminationSuccess?: boolean | undefined;

  documentsLoading?: boolean;
  documents?: {
    id: string;
    name: string;
  }[];
  documentsError?: string;
}

const initialState: RequestsState = {
  earlyContractTerminationLoading: false,
  earlyContractTerminationError: undefined,
  earlyContractTerminationSuccess: undefined,

  documentsLoading: false,
  documents: [],
  documentsError: undefined,
};

export const newRequestsSlice = createSlice({
  name: 'newRequestsSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // early termination request
    builder.addCase(sendEarlyTerminationRequest.pending, (state) => {
      state.earlyContractTerminationLoading = true;
      state.earlyContractTerminationError =
        initialState.earlyContractTerminationError;
      state.earlyContractTerminationSuccess =
        initialState.earlyContractTerminationSuccess;
    });
    builder.addCase(sendEarlyTerminationRequest.fulfilled, (state, action) => {
      state.earlyContractTerminationLoading = false;
      state.earlyContractTerminationError =
        initialState.earlyContractTerminationError;
      state.earlyContractTerminationSuccess = true;
    });
    builder.addCase(sendEarlyTerminationRequest.rejected, (state, action) => {
      state.earlyContractTerminationLoading = false;
      state.earlyContractTerminationSuccess = false;
      state.earlyContractTerminationError = action.payload
        ? (action.payload as Error)?.message
        : action.error?.message;
    });

    // fetching documents
    builder.addCase(fetchEarlyTerminationDocuments.pending, (state) => {
      state.documentsLoading = true;
      state.documentsError = initialState.documentsError;
      state.documents = initialState.documents;
    });
    builder.addCase(
      fetchEarlyTerminationDocuments.fulfilled,
      (state, action) => {
        state.documentsLoading = false;
        state.documentsError = initialState.documentsError;
        state.documents = action.payload.documents;
      },
    );
    builder.addCase(
      fetchEarlyTerminationDocuments.rejected,
      (state, action) => {
        state.documentsLoading = false;
        state.documentsError = action.payload
          ? (action.payload as Error)?.message
          : action.error?.message;
      },
    );
  },
});

export default newRequestsSlice.reducer;
